export type CursoAromaterapiaId =
  | 'pratica-consciente'
  | 'criancas'
  | 'dores'
  | 'energetica'
  | 'vibracional'

export interface AulaCurso {
  numero: number
  titulo: string
  youtubeId: string
}

export interface CursoAromaterapia {
  id: CursoAromaterapiaId
  titulo: string
  badge: string
  subtitulo: string
  intro: string[]
  topicos: string[]
  incluso?: string
  aulas: AulaCurso[]
  materialUrl: string
}

export const CURSOS_AROMATERAPIA: Record<CursoAromaterapiaId, CursoAromaterapia> = {
  'pratica-consciente': {
    id: 'pratica-consciente',
    titulo: 'Aromaterapia Prática e Consciente',
    badge: 'Curso gratuito',
    subtitulo:
      'Aprenda de forma prática e consciente a usar os óleos essenciais. A ênfase do curso é voltada para o Kit Brasil Living da doTERRA.',
    intro: [
      'Um curso direto ao ponto para você usar óleos essenciais com segurança, critério e resultado — do básico à prescrição consciente.',
    ],
    topicos: [
      'Óleo essencial: o que é, por que usar, indicações e propriedades',
      'Tipos de óleos essenciais',
      'Como usar os óleos essenciais (tópico, aromático e interno)',
      'Tabela de diluição de óleos essenciais, ingestão e uso aromático',
      'Tipos de óleos carreadores',
      'Apresentação dos 12 óleos essenciais do Kit Brasil Living doTERRA, detalhando quais são os sistemas do corpo que recebem os benefícios, formas de uso, formas de extração e principais indicações físicas e emocionais',
      'Cuidados e precauções no uso de óleos essenciais, incluindo orientações para crianças, bebês e casos específicos',
      'Como prescrever e criar protocolos com os óleos essenciais, entendendo as prioridades de cada pessoa',
      'Quanto tempo usar um óleo essencial e qual quantidade é indicada para cada tipo de sintoma físico e emocional',
      'Como criar blends personalizados',
      'Aromaterapia emocional e mudança de estilo de vida (Kit Yoga, Adaptiv e Whisper)',
    ],
    incluso: 'Material da aula, Manual Essencial e Protocolo de Uso Tópico.',
    aulas: [
      { numero: 1, titulo: 'Aula 1', youtubeId: 'INpswV0SB2A' },
      { numero: 2, titulo: 'Aula 2', youtubeId: 'GHIevqk997U' },
      { numero: 3, titulo: 'Aula 3', youtubeId: 'KztlUI29SzQ' },
      { numero: 4, titulo: 'Aula 4', youtubeId: 'Qwnluco4OPk' },
    ],
    materialUrl: 'https://drive.google.com/drive/folders/1dgtYmkuuMDz8OTNSG9-AN02p1-77_D6B',
  },
  criancas: {
    id: 'criancas',
    titulo: 'Aromaterapia para Crianças',
    badge: 'Curso gratuito',
    subtitulo:
      'Aprenda de forma segura e simples a usar os óleos essenciais em crianças e adolescentes. Incluso orientações para bebês e gestantes.',
    intro: [
      'Um curso prático e direto ao ponto. Curso baseado nos óleos essenciais da marca doTERRA.',
      'Você vai aprender detalhadamente como utilizar o Kit Kids, que contempla as seguintes misturas de óleos essenciais:',
    ],
    topicos: [
      'Descubra como usar',
      'Cuidados e recomendações para os pais',
      'Principais indicações para sono, imunidade, concentração e equilíbrio',
      '🦁 Brave® — Mix Coragem',
      '😴 Calmer® — Mix Calmante',
      '🦵 Rescuer® — Mix Conforto',
      '🐳 Steady® — Mix Equilíbrio',
      '🛡️ Stronger® — Mix Proteção',
      '🍎 Tamer® — Mix Bem-Estar',
      '🤓 Thinker® — Mix Atenção',
    ],
    aulas: [{ numero: 1, titulo: 'Aula 1', youtubeId: 'NIloKU07lgk' }],
    materialUrl: 'https://drive.google.com/drive/folders/1H5LAdVSN7lisSNrChKCGG0lNd3wk-EHW',
  },
  dores: {
    id: 'dores',
    titulo: 'Aromaterapia para Dores',
    badge: 'Curso gratuito',
    subtitulo:
      'Aprenda soluções com os óleos essenciais para dores, tensão, estresse e processos inflamatórios.',
    intro: [
      'Em casos específicos de dores, entenda como usar os óleos essenciais para atuar no equilíbrio emocional e físico, para que a saúde integral seja restaurada.',
    ],
    topicos: [
      'Descubra as combinações de óleos essenciais para massagem corporal',
      'Receitas de blends para dores de cabeça',
      'Receitas de blends para dores musculares, tensão e inflamações',
    ],
    aulas: [{ numero: 1, titulo: 'Aula 1', youtubeId: '0tBV4Vlf194' }],
    materialUrl: 'https://drive.google.com/drive/folders/102fEGTswhPhFh6NE-zmR6WQQL49C_UfW',
  },
  energetica: {
    id: 'energetica',
    titulo: 'Aromaterapia Energética',
    badge: 'Curso gratuito',
    subtitulo:
      'Aprenda como utilizar os óleos essenciais nos pontos de energia do seu corpo para trazer harmonização energética, limpeza de dores emocionais, crenças limitantes e tudo que está desequilibrado em sua vida.',
    intro: [
      'Cada um dos pontos de energia (chakras) existentes exerce influências específicas em uma ou mais áreas da nossa saúde e personalidade.',
      'Todo o conteúdo é baseado no kit de aromaterapia emocional da doTERRA.',
      'Esse conhecimento poderoso vai mudar sua vida para sempre!',
    ],
    topicos: [
      '❤️ Mix Inspirador — Passion (Espontâneo, Vivificante e Ousadia)',
      '🧡 Mix Encorajador — Motivate (Motivar, Energizar e Acreditar)',
      '💛 Mix Animador — Cheer (Alegrar, Edificar e Resiliente)',
      '💚 Mix Renovador — Forgive (Aliviar, Desprender e Libertar)',
      '💙 Mix Tranquilizador — Peace (Corajoso, Composto e Fluindo)',
      '💜 Mix Reconfortante — Console (Apoiar, Conciliar e Aliviar)',
    ],
    aulas: [{ numero: 1, titulo: 'Aula 1', youtubeId: 'ENhGvDJrruQ' }],
    materialUrl: 'https://drive.google.com/drive/folders/1_eSmkt1mBdFSZklz_fWiKNxBPPsrbYtj',
  },
  vibracional: {
    id: 'vibracional',
    titulo: 'Aromaterapia Vibracional',
    badge: 'Curso gratuito',
    subtitulo:
      'Aprenda de forma simples e prática como utilizar 24 óleos essenciais para elevar sua vibração e limpar emocionalmente as frequências negativas de vergonha, culpa, apatia, tristeza, medo, desejo, raiva e orgulho.',
    intro: [
      'Um curso poderoso que utiliza a abordagem da escala de consciência do Dr. Hawkins, associando cada frequência a óleos essenciais, para que você saiba como alcançar vibrações elevadas e desfrutar de prosperidade, plenitude e amor.',
      'Aprendendo essa prática, você acaba potencializando também a sua saúde física.',
      'Curso baseado nos óleos essenciais da doTERRA.',
    ],
    topicos: [
      'Como elevar a vibração com 24 óleos essenciais',
      'Limpeza emocional das frequências de vergonha, culpa, apatia, tristeza, medo, desejo, raiva e orgulho',
      'Escala de consciência do Dr. Hawkins associada aos óleos essenciais',
    ],
    aulas: [
      { numero: 1, titulo: 'Aula 1', youtubeId: 'Z_bHpSt4aPI' },
      { numero: 2, titulo: 'Aula 2', youtubeId: 'CN423ZmkFMo' },
      { numero: 3, titulo: 'Aula 3', youtubeId: 'VsScr_tmOxs' },
      { numero: 4, titulo: 'Aula 4', youtubeId: 'RFUfRUhPfZA' },
    ],
    materialUrl: 'https://drive.google.com/drive/folders/1KrAKFRzi9N7NW8RvP6aS5xtNEECSSLNM',
  },
}

export const CURSOS_AROMATERAPIA_LISTA = Object.values(CURSOS_AROMATERAPIA)

export function isCursoAromaterapiaId(value: string | undefined | null): value is CursoAromaterapiaId {
  return !!value && value in CURSOS_AROMATERAPIA
}

export function youtubeEmbedUrl(youtubeId: string): string {
  return `https://www.youtube-nocookie.com/embed/${youtubeId}`
}

export function linkCursoPublico(cursoId: CursoAromaterapiaId, indicadoPor: string): string {
  const slug = encodeURIComponent(indicadoPor || 'monica')
  return `https://www.descubraseusoleos.com.br/cursos/${cursoId}?indicado_por=${slug}`
}

export const ORIENTACAO_CURSO_PRESENTE =
  'Este curso é um presente estratégico — use-o como incentivo para fechar vendas ou fidelizar clientes, oferecendo o acesso como um bônus especial. Evite compartilhar o link de forma aleatória ou em massa, para manter o valor percebido do curso.'

export const LABEL_CURSO_INSCRITO: Record<string, string> = {
  'uma-gota': 'Uma Gota de Equilíbrio',
  'pratica-consciente': 'Aromaterapia Prática e Consciente',
  criancas: 'Aromaterapia para Crianças',
  dores: 'Aromaterapia para Dores',
  energetica: 'Aromaterapia Energética',
  vibracional: 'Aromaterapia Vibracional',
}

export function rotuloCursoInscrito(reg: { cursoId?: string; origem?: string }): string {
  if (reg.cursoId && LABEL_CURSO_INSCRITO[reg.cursoId]) return LABEL_CURSO_INSCRITO[reg.cursoId]
  if (reg.origem === 'Capacitacao Equipe') return 'Capacitação da Equipe'
  if (reg.origem === 'Capacitacao (negocio)') return 'Seleção para Negócio e Capacitação'
  return 'Uma Gota de Equilíbrio'
}
